export default __webpack_public_path__ + "static/media/AnimalFeaturesSpots_06.eb34965c.png";